import React from 'react';
import { COMPANY_INFO } from '../data/siteData';

export default function StickyPhoneBar() {
  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-0 inset-x-0 z-30 min-[1200px]:hidden bg-white/95 backdrop-blur-md border-t border-[#d8e3dc] p-2.5 px-4 shadow-lg"
    >
      <div className="max-w-md mx-auto flex items-center justify-between gap-3">
        <a
          href={`tel:${COMPANY_INFO.phoneRaw}`}
          className="flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl bg-[#1b4332] text-white text-sm font-semibold shadow-xs whitespace-nowrap"
        >
          <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
          <span className="whitespace-nowrap">Ring {COMPANY_INFO.phone}</span>
        </a>

        <a
          href="/kontakt"
          className="flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl bg-[#f2f7f4] border border-[#2d6a4f] text-[#1b4332] text-sm font-semibold hover:bg-[#e4eee8] whitespace-nowrap"
        >
          <i className="fa-solid fa-file-pen text-xs" aria-hidden="true" />
          <span>Få et tilbud</span>
        </a>
      </div>
    </aside>
  );
}
